import React from "react";
import { CustomButton } from "./customButton/CustomButton";

function RowButton({
  onClickNext,
  onClickBack,
  buttonname1 = "Cancel",
  buttonname2 = "Next",
  buttonStyle1,
  buttonStyle2,
  loading = false,
  showAppliedIndicator = false,
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        justifyContent: "center",
        marginTop: 20,
      }}
    >
      <CustomButton
        title={buttonname1}
        styles={{
          backgroundColor: "white",
          border: "1px solid black",
          padding: 0,
          height: "auto",
          padding: "10px",
        }}
        textStyles={{
          color: "black",
        }}
        onClick={onClickBack}
      />{" "}
      <CustomButton
        title={buttonname2}
        styles={{
          backgroundColor: "#38369C",
          border: "1px solid black",
          padding: 0,
          height: "auto",
          padding: "10px 25px",
        }}
        textStyles={{
          color: "white",
        }}
        onClick={() => {
          onClickNext();
        }}
        loading={loading}
        showChecked={showAppliedIndicator}
      />
    </div>
  );
}

export default RowButton;
